import useOpenClose from 'hooks/useOpenClose';
import { useCallback } from 'react';

export default function useModalContent(setModalContent) {
    const { isOpen, doOpen, doClose } = useOpenClose(false);

    const open = useCallback(
        content => {
            if (content) setModalContent(content);
            doOpen();
        },
        [doOpen, setModalContent]
    );

    const close = useCallback(() => {
        doClose();
        setModalContent(null);
    }, [doClose, setModalContent]);

    return { isOpen, open, close };
}
